import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { GridColDef } from '@mui/x-data-grid';

export const myUsersColumn = (): Array<GridColDef> => [
  {
    field: 'userAccount',
    flex: 1.5,
    headerName: 'Usuario',
    minWidth: 220,
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {params?.row.userAccount || '-'}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'name',
    flex: 1.5,
    headerName: 'Nombre',
    minWidth: 180,
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <Typography variant="body2" sx={{ color: (theme) => theme.palette.grey[700] }}>
          {params?.row.name || '-'}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'organization',
    flex: 1.2,
    headerName: 'Organización',
    minWidth: 150,
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <Typography variant="body2" sx={{ color: (theme) => theme.palette.grey[700] }}>
          {params?.row.organization || '-'}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'organizationType',
    flex: 1,
    headerName: 'Tipo',
    minWidth: 120,
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => {
      const type = params?.row.organizationType;
      const isPrincipal = type === 'principal';
      return (
        <Box
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
        >
          <Chip
            label={isPrincipal ? 'Principal' : 'Secundaria'}
            size="small"
            color={isPrincipal ? 'primary' : 'default'}
            sx={{ fontWeight: 500, minWidth: 90 }}
          />
        </Box>
      );
    },
  },
  {
    field: 'info',
    flex: 1.5,
    headerName: 'Información',
    minWidth: 200,
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <Typography
          variant="body2"
          sx={{ color: (theme) => theme.palette.grey[700], fontSize: '0.875rem' }}
        >
          <strong>Tel:</strong> {params?.row.phone || '-'}
        </Typography>
        <Chip
          label={params?.row.status || '-'}
          size="small"
          color={params?.row.status === 'Activo' ? 'success' : 'default'}
          sx={{ fontSize: '0.75rem', height: 20 }}
        />
      </Box>
    ),
  },
];
